import React, { useState, useEffect } from "react";
import { Button, Menu, MenuItem, Divider, ListItemIcon, IconButton } from "@mui/material";
import { Category, ExpandMore } from "@mui/icons-material";
import FolderIcon from "@mui/icons-material/Folder";
import VisibilityIcon from "@mui/icons-material/Visibility"; // Icon for Views (Submenu Items)
import AddCircleIcon from "@mui/icons-material/AddCircle"; 
import UpdateIcon from "@mui/icons-material/Update";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import PageviewIcon from "@mui/icons-material/Pageview"; // View icon for submenu items
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import axios from 'axios';
import ApiUtils from '../../../utils/apiUtils';
import base_url from '../../../baseUrls';

const CustomViewMenu = (props) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [subMenuAnchors, setSubMenuAnchors] = useState([]);
  const [subMenuVisible, setSubMenuVisible] = useState(true);
  const [optionsAnchor, setOptionsAnchor] = useState(null);
  const [viewOptionsAnchor, setViewOptionsAnchor] = useState(null);
  const [menuData, setMenuData] = useState([]);
  const [currentCustomView, setCurrentCustomView] = useState(null);
  const [optionCurCustomView, setOptionCurCustomView] = useState(null);
  const [currentCategory, setCurrentCategory] = useState('');

  const open = Boolean(anchorEl);

  const showMenuItems = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const hideMenuItems = () => {
    setAnchorEl(null);
    setSubMenuAnchors({});
    setOptionsAnchor(null);
    setViewOptionsAnchor(null);
  };

  const handleSubMenuOpen = (event, category) => {
    setSubMenuAnchors((prev) => ({ ...prev, [category]: event.currentTarget }));

    setSubMenuVisible(menuData[category].length > 1 || (menuData[category].length == 1 && !menuData[category][0].viewName.includes("XXXX")));


  };

  const handleSubMenuClose = (category) => {
    setSubMenuAnchors((prev) => ({ ...prev, [category]: null }));
  };

  const handleCreateCategory = () => {
    hideMenuItems(); // Close the dropdown after opening modal
    
    if (props.showCustomView) {

      const view = { id: 0, userId: props.userId, origView: props.origView, category: '', viewName: '', filter: '', sorting: ''};
      props.showCustomView(view, 'add', true);
    }
  };

  const handleDeleteCategory = (category) => {

    hideMenuItems(); // Close the dropdown after opening modal
    
    if (props.showCustomView) {
      const tmpViews = menuData[category];
      
      //console.log('tmp views');
      //console.log(tmpViews);

      if (tmpViews.length > 0) {
        props.showCustomView(tmpViews[0], "delete", true);
      }
    }
  };

  const handleCreateNewView = (category) => {
    hideMenuItems(); // Close the dropdown after opening modal
    
    if (props.showCustomView) {

      const view = { id: 0, userId: props.userId, origView: props.origView, category: category, viewName: '', filter: '', sorting: ''};
      props.showCustomView(view, 'add');
    }
  };

  // const handleCreateNewView = () => {
  //   hideMenuItems(); // Close the dropdown after opening modal
    
  //   if (props.showCustomView) {

  //     const view = { id: 0, userId: props.userId, origView: props.origView, category: currentCategory, viewName: '', filter: '', sorting: ''};
  //     props.showCustomView(view, 'add');
  //   }
  // };

  const handleSaveCurrentView = (crudAction, view) => {

    hideMenuItems(); // Close the dropdown after opening modal
    
    if (props.showCustomView) {
      props.showCustomView(view, crudAction);
    }
  };

  // const handleSaveCurrentView = (crudAction) => {

  //   hideMenuItems(); // Close the dropdown after opening modal
    
  //   if (props.showCustomView) {
  //     props.showCustomView(optionCurCustomView, crudAction);
  //   }
  // };

  const handleSaveCurrentViewFromTopLevel = (crudAction) => {

    hideMenuItems(); // Close the dropdown after opening modal
    
    if (props.showCustomView) {
      props.showCustomView(currentCustomView, crudAction);
    }
  };



  const handleDefaultView = async (customView) => {
    setCurrentCustomView(customView);
    hideMenuItems();
    if (props.changeCurrentView) {
      props.changeCurrentView(null);
    }
  };

  const handleMenuItemClick = async (customView) => {
    setCurrentCustomView(customView);
    hideMenuItems();
     
    if (props.changeCurrentView) {
      props.changeCurrentView(customView);
    }
  };

  const handleOptionsClick = (event, category) => {
    setOptionsAnchor(event.currentTarget);
    setCurrentCategory(category);
  };

  const handleOptionsClose = () => {
    setOptionsAnchor(null);
    setCurrentCategory('');
   // hideMenuItems();
  };


  const handleViewOptionsClick = async (event, view) => {

    setOptionCurCustomView(view);
    //await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 1 seconds
    setViewOptionsAnchor(event.currentTarget);
  };


  const handleViewOptionsClose = () => {
    setViewOptionsAnchor(null);
    setOptionCurCustomView(null);
    //hideMenuItems();
  };

  const groupDataByCategory = (data) => {  

    return data.reduce((acc, item) => {
      if (!acc[item.category]) {
        acc[item.category] = [];
      }
      acc[item.category].push({ 
        id: item.id,
        userId: item.userId, 
        origView: item.origView, 
        category: item.category,
        viewName: item.viewName, 
        filter: item.filter,
        extendedFilter: item.extendedFilter,
        sorting: item.sorting,
      });
      return acc;
    }, {});
  };

  useEffect (async () => {

    //console.log('new Custom view id');
    //console.log(props);
    //console.log(props.newCustomViewId);

    const authToken =  await ApiUtils.getAccessToken();
    const url = `${base_url.api}customViews/get-by-user`;
    const body = { "userId": props?.userId, "origView": props?.origView };

    axios.post(url, body, {headers: {Authorization: authToken,}}).then ((data) => {
      
      if (!props.newCustomViewId || props.newCustomViewId === '') {
        
        const lookupView = data.data.data.customViews.find(x => x?.id == currentCustomView?.id);

        if (lookupView) {
          setCurrentCustomView(lookupView);
        }
        else {
          setCurrentCustomView(null);
        }
      }
      else {
        const newView = data.data.data.customViews.find(x => x?.id == props.newCustomViewId);
        setCurrentCustomView(newView);
      }
   
      const viewMenu = groupDataByCategory(data.data.data.customViews);
      const defaultMenu = {};
      defaultMenu["Default View"] = [];
      defaultMenu["Create New View"] = [];
      defaultMenu["Update"] = [];
      const mergedObject = Object.assign({}, defaultMenu, viewMenu);

      setMenuData(mergedObject);
    });

  },[anchorEl])

  return (
    <div>
      <Button
        variant="contained"
        sx={{ backgroundColor: "black", color: "white", "&:hover": { backgroundColor: "#333" } }}
        onClick={showMenuItems}
        endIcon={<ExpandMore />}
      >My Views</Button>
       <Menu anchorEl={anchorEl} open={open} onClose={hideMenuItems}>
        {Object.entries(menuData).map(([category, views], index, array) => (
          <div key={category}>
            {index === 0 && <>
              <MenuItem onClick={handleDefaultView} sx={{ color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}>
                <ListItemIcon>
                  <PageviewIcon sx={{ color: "navy" }} /> 
                </ListItemIcon>
                Default View
              </MenuItem>                       
              <Divider sx={{ my: 1 }} />            
            </>}
            {index === 1 && <>
              <MenuItem onClick={handleCreateCategory} sx={{ color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}>
                <ListItemIcon>
                  <AddCircleIcon sx={{ color: "navy" }} /> 
                </ListItemIcon>
                Create New Category
              </MenuItem>
              <Divider sx={{ my: 1 }} />            
            </>}
            {index === 2 && <>
              {currentCustomView && !currentCustomView?.viewName?.includes("XXXX") && <>        
                <MenuItem onClick={() => handleSaveCurrentViewFromTopLevel('save')} sx={{ color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}>
                  <ListItemIcon>
                    <SaveIcon sx={{ color: "navy" }} /> 
                  </ListItemIcon>
                  Save - {currentCustomView.viewName}
                </MenuItem>
                <Divider sx={{ my: 1 }} />
              </>}
            </>}
            {index >= 3 && <>
              <MenuItem                
                aria-haspopup="true"
                sx={{color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0}}                
              >
                <div onClick={(e) => handleSubMenuOpen(e, category)} 
                     style={{ display: "flex", alignItems: "left", marginRight:'15px' }}>
                  <ListItemIcon>
                    <FolderIcon sx={{ color: "navy" }} />
                  </ListItemIcon>
                  {category}
                </div>             
                <div style={{ marginLeft: "auto" }}>
                  <IconButton size="small" onClick={(e) => handleCreateNewView(category)}>
                    <AddCircleIcon sx={{ color: "navy" }} /> 
                  </IconButton>
                  <IconButton size="small" disabled={menuData[category].length > 1 || (menuData[category].length == 1 && !menuData[category][0].viewName.includes("XXXX"))}
                       onClick={(e) => handleDeleteCategory(category)} >
                    {menuData[category].length > 1 || (menuData[category].length == 1 && !menuData[category][0].viewName.includes("XXXX"))
                      ? <DeleteIcon sx={{ color: "grey" }} /> 
                      : <DeleteIcon sx={{ color: "maroon" }} /> }
                  </IconButton>
                </div>

                {/* Three-dot button for actions */}
                {/* <IconButton size="small" onClick={(e) => handleOptionsClick(e, category)} sx={{ marginLeft: "auto" }}>
                  <MoreHorizIcon />
                </IconButton> */}
              </MenuItem>
            </>} 
           {subMenuVisible && 
             <Menu
              anchorEl={subMenuAnchors[category]}
              open={Boolean(subMenuAnchors[category])}
              onClose={() => handleSubMenuClose(category)}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              {views.map((view) => {
                if (view.viewName.includes("XXXX")) return null;
                return (
                <MenuItem key={view.id}  
                  sx={{ color: "rgb(49, 82, 163)", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}
                >   
                    <div style={{ display: "flex", alignItems: "left", marginRight:'15px' }}
                       onClick={() => handleMenuItemClick(view)} >
                      <ListItemIcon>
                        {view.viewName == currentCustomView?.viewName ? <CheckBoxIcon color="navy" /> :  <PageviewIcon color="navy" />}
                      </ListItemIcon >
                      {view.viewName}                    
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <IconButton size="small" onClick={(e) => handleCreateNewView(view.category)}>
                        <AddCircleIcon sx={{ color: "navy" }} /> 
                      </IconButton>
                      <IconButton size="small" onClick={(e) => handleSaveCurrentView('save', view)}>
                        <SaveIcon sx={{ color: "navy" }} /> 
                      </IconButton>
                      <IconButton size="small" onClick={(e) => handleSaveCurrentView('delete', view)}>
                        <DeleteIcon sx={{ color: "maroon" }} /> 
                      </IconButton>
                      {/* <IconButton size="small" onClick={(e) => handleViewOptionsClick(e, view)} >
                        <MoreHorizIcon />
                      </IconButton> */}
                    </div>
                </MenuItem>)
              })}
            </Menu>
            }
            {/* Dropdown Menu for "..." Category */}
            <Menu
              anchorEl={optionsAnchor}
              open={Boolean(optionsAnchor)}
              onClose={() => handleOptionsClose()}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem onClick={handleCreateNewView} sx={{ color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}>
                <ListItemIcon>
                  <AddCircleIcon sx={{ color: "navy" }} /> 
                </ListItemIcon>
                Create New View
              </MenuItem>
            </Menu>
            {/* Dropdown Menu for "..." view */}
            {/* <Menu
              anchorEl={viewOptionsAnchor}
              open={Boolean(viewOptionsAnchor)}
              onClose={() => handleViewOptionsClose()}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem 
                onClick={ () => handleSaveCurrentView('save')} 
                disabled={currentCustomView?.id != optionCurCustomView?.id}
                sx={{ color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}
              >
                <ListItemIcon>
                  <SaveIcon sx={{ color: "navy" }} /> 
                </ListItemIcon>
                Save View
              </MenuItem>
              <Divider sx={{ my: 1 }} />
              <MenuItem 
                onClick={ () => handleSaveCurrentView('delete')}      
                sx={{ color: "Black", mt: 0.25, mb: 0.25, pt: 0, pb: 0 }}
              >
                <ListItemIcon>
                  <DeleteIcon sx={{ color: "navy" }} /> 
                </ListItemIcon>
                Delete View
              </MenuItem>
            </Menu> */}

          </div>
        ))}
      </Menu>
    </div>
  );
};

export default CustomViewMenu;
